import Vue from 'vue';

const success = (context, response) => {
  const newBlob = new Blob([response], { type: 'application/pdf' });
  const data = window.URL.createObjectURL(newBlob);
  const filename = `${context.contract.rental_name} - Contract ${context.contract.booking_id} - ${context.contract.tenant_first_name} ${context.contract.tenant_last_name}.pdf`;
  const link = document.createElement('a');
  link.href = data;
  link.download = filename;
  link.click();
  context.loading = false;
};

const failed = (context, error) => {
  context.loading = false;
  context.showToasterError(error);
};

export default (context, permalink) => Vue.$http.get(`download-contract/${permalink}`, { responseType: 'arraybuffer' })
    .then((response) => {
      if (response && response.status === 200) {
        success(context, response.data);
      } else {
        failed(context, response);
      }
    }).catch((error) => {
      if (error) {
        failed(context, error);
      }
    });



// WEBPACK FOOTER //
// ./src/app/services/booking/downloadContract.js